import React from 'react';
import Show from 'shared/components/Referrals/Show';

export default props => (
  <Show
    {...props}
    apiEndpoint="/agent_portal/api"
    webpageBase="/a/portal"
    serverWebpageBase="/agent_portal"
  />
);
